import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import {
  SharedModule,
  CustomDetailComponent,
  DataService,
} from "@bb-vendure/admin-ui/core";
import { Observable, switchMap, of } from "rxjs";
import { IdolNamePipe } from "./pipes/idol-name.pipe";
import { CountryPipe } from "./pipes/country.pipe";

interface EntrantInfo {
  eventId: number;
  productVariantId: number;
  idolId: number;
  id: string;
  birhtdate: Date;
  firstName: string;
  lastName: string;
  countryCode: string;
  phoneNumber: string;
  email: string;
  contactInfoType: string;
}
@Component({
  template: `
    <vdr-card
      [title]="'order.entrant-info' | translate"
      style="margin-bottom: calc(var(--space-unit) * 3)"
    >
      <div class="entrant-info-container" style="overflow-x: auto;">
        <table class="table" *ngIf="(data$ | async)?.length > 0">
          <thead>
            <tr>
              <th>{{ "event.idol" | translate }}</th>
              <th>{{ "common.id" | translate }}</th>

              <th>{{ "event.contact-info-type" | translate }}</th>
              <th>{{ "common.name" | translate }}</th>
              <th>{{ "supplier.email" | translate }}</th>
              <th>{{ "warehouse.telephone" | translate }}</th>
              <th>{{ "event.birthdate" | translate }}</th>
              <th>{{ "common.country" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of data$ | async">
              <td>{{ item.idolId | idolName | async }}</td>
              <td>{{ item.id }}</td>
              <td>{{ item.contactInfoType }}</td>
              <td>{{ item.firstName }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.phoneNumber }}</td>
              <td style="white-space: nowrap;">
                {{ item.birhtdate | localeDate : "shortDate" }}
              </td>
              <td>{{ item.countryCode | country | async }}</td>
            </tr>
          </tbody>
        </table>
        <p *ngIf="!(data$ | async)?.length">
          No entrant information available.
        </p>
      </div>
    </vdr-card>
  `,
  standalone: true,
  providers: [DataService],
  imports: [SharedModule, IdolNamePipe, CountryPipe],
})
export class EntrantInfoComponent implements CustomDetailComponent, OnInit {
  entity$: Observable<any>;
  detailForm: UntypedFormGroup;

  data$: Observable<EntrantInfo[]>;
  ngOnInit() {
    this.data$ = this.entity$.pipe(
      switchMap((entity) => {
        const entrants: EntrantInfo[] = [];

        const entrantInfoSet = new Set();

        for (const line of entity.lines) {
          if (!line.customFields.entrant && !line.customFields.entrantInfo) {
            continue;
          }

          let key = "";

          if (line.customFields.idol) {
            key = `idol:${line.customFields.idol.id}|entrant:${line.customFields.entrant.id}`;
          } else {
            key = `entrant:${line.customFields.entrant.id}`;
          }

          if (!entrantInfoSet.has(key)) {
            try {
              const entrantInfo = JSON.parse(line.customFields.entrantInfo);
              entrants.push({
                eventId: 0,
                productVariantId: 0,
                idolId: entrantInfo.idol?.id ?? null,
                id: entrantInfo.id,
                birhtdate: entrantInfo.birhtdate,
                firstName: entrantInfo.firstName,
                lastName: "",
                countryCode: entrantInfo.countryId,
                phoneNumber: entrantInfo.phoneNumber,
                email: entrantInfo.email,
                contactInfoType: entrantInfo.contactInfoType,
              });
              entrantInfoSet.add(key);
            } catch (error) {
              entrants.push({
                eventId: 0,
                productVariantId: 0,
                idolId: line.customFields.idol?.id ?? null,
                id: line.customFields.entrant.infoId,
                birhtdate: line.customFields.entrant.birhtdate,
                firstName: line.customFields.entrant.firstName,
                lastName: "",
                countryCode: line.customFields.entrant.countryId,
                phoneNumber: line.customFields.entrant.phoneNumber,
                email: line.customFields.entrant.email,
                contactInfoType: line.customFields.entrant.contactInfoType,
              });
              entrantInfoSet.add(key);
            }
          }
        }

        return of(entrants);
      })
    );
  }
}
